import { version } from '../package.json'
import * as logger from '@mamdev/navigator.frontend-logger'
import { isSentryLoaded, initSentry } from './util/sentry'
import { authorize } from './intermediate'
import { getLogLevel } from './util/log-level'
import { getBrand } from './util/brand'
import { applyBrandStyles } from './util/brand-styles'
import { setStlCookie } from './util/stl-cookie'
import { initMonitoring } from './util/monitoring'

logger.setLogLevel(getLogLevel())
initMonitoring()

let brandStylesApplied = false

document.addEventListener('readystatechange', () => {
  if (!brandStylesApplied) {
    applyBrandStyles(getBrand())
    brandStylesApplied = true
  }
});

window.addEventListener('load', async () => {
  try {
    if (isSentryLoaded()) {
      initSentry()
    }
  } catch (e) {
    // istanbul ignore next
    logger.warn('auth-intermediate: Sentry not initialized', e)
  }

  document.documentElement.setAttribute('data-version', version)
  setStlCookie()

  await authorize()
})
